const state = {
  products: null
};

export default state